let tooltip = null;

function showTooltip() {
  if (tooltip) {
    tooltip.tooltip('dispose');
  }

  tooltip = $('[data-toggle="tooltip"].jb-show-tooltip').first();
  tooltip.tooltip({
    template: '<div class="tooltip jb-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
  });
  tooltip.tooltip('show');
}

function onInitOrRender() {
  if (window.$inBuilderMode) {
   showTooltip();
  }
}

document.addEventListener('DOMContentLoaded', onInitOrRender);
document.addEventListener('jb.section.rendered', onInitOrRender);
document.addEventListener('section.initiated', onInitOrRender);
